import { UserDto } from '../dto/user.dto';
import { UserRole } from '../enums/user-role.enum';

/**
 * Entity klasa User - zawiera logikę biznesową
 * Tworzona z UserDto zwracanego z backendu
 */
export class UserEntity {
  id: number;
  firstName: string;
  lastName: string | null;
  photo: string | null;
  role: string;
  email: string;
  permissions: string[];
  private _mfaEnabled: boolean = false; // Wewnętrzny stan MFA

  constructor(dto: UserDto) {
    this.id = dto.id;
    this.firstName = dto.firstName;
    this.lastName = dto.lastName;
    this.photo = dto.photo;
    this.role = dto.role;
    this.email = dto.email;
    this.permissions = dto.permissions || [];
  }

  /**
   * Pełne imię i nazwisko użytkownika
   */
  get fullName(): string {
    const parts = [this.firstName, this.lastName].filter(Boolean);
    return parts.length > 0 ? parts.join(' ') : this.email;
  }

  /**
   * Inicjały użytkownika (pierwsze litery imienia i nazwiska)
   */
  get initials(): string {
    const firstInitial = this.firstName?.charAt(0) || '';
    const lastInitial = this.lastName?.charAt(0) || '';
    return (firstInitial + lastInitial).toUpperCase() || this.email.charAt(0).toUpperCase();
  }

  /**
   * Czy użytkownik jest gościem?
   */
  get isGuest(): boolean {
    return this.role === 'guest';
  }

  /**
   * Czy gość wciąż ma ważny dostęp? (kompatybilność - zawsze false dla non-guest)
   */
  get isGuestExpired(): boolean {
    return false; // Backend nie wysyła expiresAt, więc zakładamy że ważny
  }

  /**
   * Czy użytkownik ma włączone MFA?
   */
  get mfaEnabled(): boolean {
    return this._mfaEnabled;
  }

  set mfaEnabled(value: boolean) {
    this._mfaEnabled = value;
  }

  /**
   * Czy użytkownik ma dane uprawnienie?
   */
  hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }
}
